"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ExportedUpdateRequest_1 = require("../model/ExportedUpdateRequest");

var ExportedUpdateRequestConverter_1 = require("./ExportedUpdateRequestConverter");
/**
 * @author Radek Beran
 */


var ExportedUpdateRequestConverterImpl =
/*#__PURE__*/
function (_ExportedUpdateReques) {
  _inherits(ExportedUpdateRequestConverterImpl, _ExportedUpdateReques);

  function ExportedUpdateRequestConverterImpl() {
    _classCallCheck(this, ExportedUpdateRequestConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedUpdateRequestConverterImpl).apply(this, arguments));
  }

  _createClass(ExportedUpdateRequestConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ExportedUpdateRequest_1.ExportedUpdateRequest(ExportedUpdateRequest_1.ExportedUpdateRequest.schema.exported.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        exported: source.exported
      });
      return result;
    }
  }]);

  return ExportedUpdateRequestConverterImpl;
}(ExportedUpdateRequestConverter_1.ExportedUpdateRequestConverter);

exports.ExportedUpdateRequestConverterImpl = ExportedUpdateRequestConverterImpl;